<template>
  <label
    class="base-radio"
    :class="[
      `base-radio-${variant}`,
      {
        checked,
        disabled
      }
    ]"
  >
    <input
      class="base-radio-input"
      type="radio"
      :name="name"
      :value="optionValue"
      :checked="checked"
      :disabled="disabled"
      @change="handleChange"
    >
    <span class="base-radio-marker" aria-hidden="true"></span>
    <span v-if="$slots.default" class="base-radio-content">
      <slot></slot>
    </span>
  </label>
</template>

<script>
// 常量：基础单选组件视觉类型，default 用于表单行，compact 用于仅展示圆点
const RADIO_VARIANTS = ['default', 'compact']

export default {
  name: 'BaseRadio',
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    // 关键状态：父组件通过 v-model 传入当前选中的值
    value: {
      type: [String, Number, Boolean],
      default: ''
    },
    // 常量参数：当前单选项的值
    optionValue: {
      type: [String, Number, Boolean],
      required: true
    },
    // 常量参数：原生 radio name，用于同组语义
    name: {
      type: String,
      default: ''
    },
    // 常量参数：控制不同业务位置的视觉间距
    variant: {
      type: String,
      default: 'default',
      validator(value) {
        return RADIO_VARIANTS.indexOf(value) > -1
      }
    },
    // 逻辑分支：禁用态用于不可选业务项
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // 方法：判断当前单选项是否命中父级选中值
    checked() {
      return this.value === this.optionValue
    }
  },
  methods: {
    // 方法：把原生 radio 的选择结果同步给父组件 v-model
    handleChange() {
      if (this.disabled) {
        return
      }

      this.$emit('input', this.optionValue)
      this.$emit('change', this.optionValue)
    }
  }
}
</script>

<style scoped lang="less">
.base-radio{
  position: relative;
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;

  &.disabled{
    cursor: not-allowed;
    opacity: 0.48;
  }
}

.base-radio-input{
  position: absolute;
  left: 0;
  top: 0;
  width: 18px;
  height: 18px;
  margin: 0;
  opacity: 0;
  cursor: pointer;

  &:disabled{
    cursor: not-allowed;
  }
}

.base-radio-marker{
  width: 18px;
  height: 18px;
  border: 1px solid #00000059;
  border-radius: 50%;
  background: #fff;
  display: inline-block;
  flex: 0 0 auto;
  box-sizing: border-box;
  pointer-events: none;
}

.base-radio.checked{
  .base-radio-marker{
    border: 6px solid #2E74FF;
  }
}

.base-radio-content{
  min-width: 0;
  margin-left: 12px;
  display: inline-flex;
  align-items: center;
}

.base-radio-compact{
  width: 18px;
  height: 18px;

  .base-radio-content{
    display: none;
  }
}
</style>
